// extracted by mini-css-extract-plugin
export default {"main":"TipoEmailSelector_main__UxRpf"};